import { BusinessObject } from './business-object.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import type { TsCodeType } from '../types.js'

@jsonClass('DataType')
export class DataType extends BusinessObject {
	@jsonProperty(String)
	declarationTs: TsCodeType = ''

	constructor(init?: Partial<DataType>) {
		super()
		assignCommonProperties(this, init)
	}
}
